import { SVGProps } from 'react';

const CornerLeftDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4 15 5 5 5-5m-5 5V8a4 4 0 0 1 4-4h7"
    />
  </svg>
);
export default CornerLeftDown;
